/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Source_ScheduleInputs */

const vi_irrigation_run_source_schedule = /** @type {(inputs: Irrigation_Run_Source_ScheduleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Theo lịch`)
};

/**

* @param {Irrigation_Run_Source_ScheduleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_source_schedule = /** @type {((inputs?: Irrigation_Run_Source_ScheduleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Source_ScheduleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_source_schedule(inputs)
});